<template>
    <div class="examine" v-loading="loading">
        <div class="examine-first">
            <div class="examine-first-view">
                <div class="examine-first-list">
                    <div class="first-list-block" v-for="(item, index) in 6" :key="index">
                        <div class="list-block-title">
                            {{
        index == 0
            ? '用户id'
            : index == 1
                ? '用户id状态'
                : index == 2
                    ? '用户昵称'
                    : index == 3
                        ? '用户手机号'
                        : index == 4
                            ? '用户类型'
                            : '购买VIP'
    }}
                        </div>
                        <div class="list-block-input">
                            <el-input v-if="index == 0" v-model="userId" clearable placeholder="请输入用户id"></el-input>

                            <el-input v-if="index == 2" v-model="userName" clearable placeholder="请输入用户昵称"></el-input>

                            <el-input v-if="index == 3" v-model="userPhone" clearable placeholder="请输入用户电话"></el-input>

                            <el-select v-if="index == 1" v-model="userIdstatus" clearable placeholder="请选择">
                                <el-option v-for="item in userIdOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>

                            <el-select v-if="index == 4" v-model="userType" placeholder="请选择" clearable>
                                <el-option v-for="item in userTypeOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>

                            <el-select v-if="index == 5" v-model="userTypeVip" placeholder="请选择" clearable>
                                <el-option v-for="item in userTypeOptionsvip" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>

                <div class="examine-first-button">
                    <div class="examine-first-button-left" @click="examineInquire">
                        查询
                    </div>
                    <div class="examine-first-button-right" @click="examineReset">
                        重置
                    </div>
                </div>
            </div>
        </div>

        <div class="examine-second">
            <div class="examine-second-header">查询结果</div>
            <div class="examine-second-table">
                <el-table :data="tableData" border style="width: 100%; cursor: pointer" :header-cell-style="{
        color: '#333333',
        backgroundColor: '#FAFAFA',
    }">
                    <!-- 自定义暂无数据 -->
                    <template slot="empty">
                        <div class="empty-block">
                            <img class="empty-block-img" src="../../assets/common/common-empty.png" />
                            <div class="empty-block-text">暂无数据～</div>
                        </div>
                    </template>
                    <el-table-column prop="id" label="用户ID" width="80">
                    </el-table-column>
                    <el-table-column prop="phone" label="用户手机号" width="136">
                    </el-table-column>
                    <el-table-column prop="nickname" label="用户昵称" width="166">
                    </el-table-column>
                    <el-table-column label="用户类型" width="120">
                        <template slot-scope="scope">
                            {{ scope.row.collaborateStatus == 1 ? scope.row.collaborateLevel == 1 ? '初级合伙人' :
        scope.row.collaborateLevel == 2 ? '精英合伙人' : scope.row.collaborateLevel == 3 ? '事业合伙人' : '' :
        '普通用户' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="购买VIP" width="120">
                        <template slot-scope="scope">
                            <div :style="{ 'color': scope.row.isVip == 0 ? '#F759AB' : '#36C100' }">
                                {{ scope.row.isVip == 0 ? '否' : '是' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="use_integral" label="用户可用积分" width="130">
                    </el-table-column>
                    <el-table-column prop="add_integral" label="用户累计积分" width="130">
                    </el-table-column>
                    <el-table-column prop="spend" label="累计消费金额(元)" width="160">
                    </el-table-column>
                    <el-table-column prop="earnestMoney" label="账户余额(元)" width="160">
                    </el-table-column>
                    <el-table-column label="用户ID状态" width="160">
                        <template slot-scope="scope">
                            <div class="table-userStatus" :style="{
        color:
            scope.row.is_suosi_switch == 0 &&
                scope.row.is_zhuxiao_switch == 0
                ? '#36C100'
                : scope.row.is_suosi_switch == 1
                    ? '#F759AB'
                    : scope.row.is_zhuxiao_switch == 1
                        ? '#999999'
                        : '',
    }">
                                {{
        scope.row.is_suosi_switch == 0 &&
            scope.row.is_zhuxiao_switch == 0
            ? '正常使用'
            : scope.row.is_suosi_switch == 1
                ? '平台冻结'
                : scope.row.is_zhuxiao_switch == 1
                    ? '用户注销'
                    : ''
    }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="注册时间" width="180">
                    </el-table-column>
                    <el-table-column prop="UA" label="注册来源" width="120">
                    </el-table-column>
                    <el-table-column prop="inviteUserNum" label="邀请用户(人)" width="120">
                    </el-table-column>
                    <el-table-column label="操作" width="126">
                        <template slot-scope="scope">
                            <div class="table-operation">
                                <div class="table-operation-left" @click="examineBtn(scope.row)">
                                    查看
                                </div>
                                <div class="table-operation-right" :style="{
        color:
            scope.row.is_suosi_switch == 0 &&
                scope.row.is_zhuxiao_switch == 0
                ? ''
                : '#ED6D1F',
    }" @click="deblockingBtn(scope.row)">
                                    {{
        scope.row.is_suosi_switch == 0 &&
            scope.row.is_zhuxiao_switch == 0
            ? '冻结'
            : '解封'
    }}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="examine-second-Pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="prev, pager, next, sizes"
                    :total="userTotalNum">
                </el-pagination>
            </div>
        </div>

        <!-- 冻结/解封 -->
        <div class="freeze">
            <el-dialog :visible.sync="quitDialogVisible" width="394px" style="margin-top: 15vh" :show-close="false">
                <span slot="footer" class="dialog-footer">
                    <div class="freeze-div">
                        <img class="freeze-div-img" src="../../assets/common/common-warning.png" />
                        <div class="freeze-div-title">
                            {{
                            freezeShow == false
                            ? '请确定是否冻结该ID？'
                            : '请确定是否解封该ID？'
                            }}
                        </div>
                        <div class="freeze-div-text">
                            {{
                            freezeShow == false
                            ? '一旦确定后，则该用户id进行冻结，用户无法进行登录并且无法进行任何操作。'
                            : '一旦确定后，则该用户id进行解封，用户进行登录并且进行任何操作。'
                            }}
                        </div>
                        <div class="freeze-div-button">
                            <div class="freeze-div-button-left" @click="quitRegister">
                                确定
                            </div>
                            <div class="freeze-div-button-right" @click="quitDialogVisible = false">
                                取消
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import Bus from '../../utils/bus'
import { getuserList, getuserDeblocking } from '../../api/user'
export default {
    components: {},
    comments() { },
    data() {
        return {
            // 用户id
            userId: '',
            // 用户id状态
            userIdstatus: '',
            userIdOptions: [
                {
                    value: '0',
                    label: '全部',
                },
                {
                    value: '1',
                    label: '用户注销',
                },
                {
                    value: '2',
                    label: '平台冻结',
                },
                {
                    value: '3',
                    label: '正常使用',
                },
            ],
            // 用户昵称
            userName: '',
            // 用户手机号
            userPhone: '',
            // 用户类型
            userType: '',
            userTypeOptions: [
                {
                    value: '0',
                    label: '普通用户',
                },
                {
                    value: '1',
                    label: '初级合伙人',
                },
                {
                    value: '2',
                    label: '精英合伙人',
                },
                {
                    value: '3',
                    label: '事业合伙人',
                },
            ],
            // 用户类型
            userTypeVip: '',
            userTypeOptionsvip: [
                {
                    value: '0',
                    label: '否',
                },
                {
                    value: '1',
                    label: '是',
                },
            ],
            // 表格列表总数
            userTotalNum: 0,

            // 第二块区域
            // 表格数组
            tableData: [],
            // 表格页数
            page: 1,
            // 表格每页条数
            limit: 10,
            // 弹出框冻结/解封  开启
            quitDialogVisible: false,
            // 监听用户刷新
            loading: false,
            // 获取当前列表点击的id存储
            itemId: '',
            // 获取当前列表点击的是否冻结还是解封
            freezeShow: false,
            // 控制当前页面功能性按钮开关
            userFunShow: false,
        }
    },
    created() {
        // 获取用户列表数据
        this.loading = true
        this.getuserExamine()

        setTimeout(() => {
            this.userFunShow = this.$store.state.pageFunctionShow

        }, 1000);
    },
    methods: {
        // 获取用户列表接口数据
        getuserExamine() {
            let params = {
                userId: this.userId, // 用户id
                userName: this.userName, // 用户名称
                userPhone: this.userPhone, // 用户电话
                isVip: this.userTypeVip, // 购买VIP 1是
                collaborateLevel: this.userType,
                is_suosi_switch:
                    this.userIdstatus == 0
                        ? ''
                        : this.userIdstatus == 2
                            ? 1
                            : this.userIdstatus == 3
                                ? 0
                                : '', // 状态:0=正常,1=已上锁
                is_zhuxiao_switch:
                    this.userIdstatus == 0
                        ? ''
                        : this.userIdstatus == 1
                            ? 1
                            : this.userIdstatus == 3
                                ? 0
                                : '', // 状态:0=正常,1=已注销
                pageSize: this.limit, // 页码
                pageNo: this.page, // 页数
            }

            getuserList(params).then((res) => {
                if (res.resultStatus == true) {
                    console.log('获取列表数据', res)
                    // 获取表格数组
                    this.tableData = res.resultData.userList
                    // 获取总数
                    this.userTotalNum = res.resultData.totalNum
                    this.loading = false
                }
            })
        },
        // 第一区域搜索查询
        examineInquire() {
            console.log('获取用户是否注销', this.userIdstatus)
            this.page = 1
            this.loading = true
            this.$nextTick(() => {
                this.getuserExamine()
            })
        },
        // 第一区域重置按钮
        examineReset() {
            this.userId = ''
            this.userName = ''
            this.userPhone = ''
            this.userIdstatus = ''
            this.userType = ''

            this.$nextTick(() => {
                this.getuserExamine()
            })
        },

        // 操作   查看
        examineBtn(item) {
            if (this.userFunShow == false) {
                return
            }

            Bus.$emit('log', 'userDetails', item)
        },
        // 操作   解封 冻结
        deblockingBtn(item) {
            if (this.userFunShow == false) {
                return
            }

            this.itemId = item.id
            this.freezeShow =
                item.is_suosi_switch == 0 && item.is_zhuxiao_switch == 0 ? false : true
            this.quitDialogVisible = true
        },
        // 用户冻结或者解封弹框确认
        quitRegister() {
            console.log('用户点击确认')
            // 获取用户解封数据
            let params = this.itemId
            getuserDeblocking(params).then((res) => {
                if (res.resultStatus == true) {
                    console.log('解封数据', res)
                    this.$message.success(
                        this.freezeShow == false ? '冻结成功' : '解封成功'
                    )

                    this.getuserExamine()
                    this.quitDialogVisible = false
                }
            })
        },

        // 子组件发送方法进行开启弹窗
        examineDetails(item) {
            console.log('触发')
            this.quitDialogVisible = true
        },

        // 查询当前页码多少条
        handleSizeChange(val) {
            this.limit = val
            this.loading = true
            this.getuserExamine()
            console.log(`每页 ${val} 条`)
        },
        // 查询当前页
        handleCurrentChange(val) {
            this.page = val
            this.loading = true
            this.getuserExamine()
            console.log(`当前页: ${val}`)
        },
    },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
}

/deep/ .el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
    border-color: #dcdfe6;
}

.examine {
    .examine-first {
        width: 100%;
        height: 180px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;
        padding: 0 24px;
        display: flex;
        align-items: center;

        .examine-first-view {
            .examine-first-list {
                display: flex;

                .first-list-block {
                    width: 180px;
                    margin-right: 25px;

                    .list-block-title {
                        height: 17px;
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 17px;
                        margin-bottom: 4px;
                    }

                    .list-block-input {
                        width: 180px;
                        height: 32px;
                        background: #ffffff;
                        border-radius: 5px;

                        /deep/ .el-input {
                            width: 180px;
                            height: 32px;
                        }

                        /deep/ .el-input__inner {
                            padding: 0 10px;
                            box-sizing: border-box;
                            height: 32px;
                            background-color: rgba(255, 255, 255, 0);
                        }

                        /deep/ .el-input__inner::-webkit-input-placeholder {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #cacaca;
                            line-height: 32px;
                        }

                        /deep/ .el-select .el-input.is-focus .el-input__inner {
                            border-color: rgba(217, 217, 217, 1);
                        }
                    }
                }
            }

            .examine-first-button {
                width: 100%;
                height: 36px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                margin-top: 27px;

                .examine-first-button-left,
                .examine-first-button-right {
                    text-align: center;
                    width: 110px;
                    height: 36px;
                    background: #222222;
                    border-radius: 10px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 36px;
                    cursor: pointer;
                }

                .examine-first-button-right {
                    background: #f4f5f9;
                    color: #999999;
                    margin-left: 10px;
                }
            }
        }
    }

    .examine-second {
        margin-top: 24px;
        background: #ffffff;
        padding: 0 24px;
        box-sizing: border-box;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;

        .examine-second-header {
            height: 68px;
            width: 100%;
            line-height: 68px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #222222;
        }

        .examine-second-table {
            /deep/ .el-table thead {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #333333;
                background: #d8d8d8;
            }

            /deep/ .el-table tr {
                height: 46px;
            }

            /deep/ .el-table__empty-text {
                line-height: 0;
            }

            .empty-block {
                margin-top: 62px;
                padding-bottom: 40px;

                .empty-block-img {
                    width: 130px;
                    height: 130px;
                    margin: 0 auto;
                }

                .empty-block-text {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 10px;
                    height: 17px;
                    line-height: 17px;
                }
            }

            .table-userStatus {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
            }

            .table-operation {
                display: flex;
                width: 100%;
                height: 100%;
                align-items: center;

                .table-operation-left,
                .table-operation-right {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #2aa4ff;
                    text-decoration: underline;
                }

                .table-operation-right {
                    margin-left: 24px;
                    color: #555555;
                    text-decoration: underline;
                }
            }
        }

        .examine-second-Pagination {
            height: 88px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            /deep/ .el-pagination .btn-prev {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                margin-right: 8px;
            }

            /deep/ .el-pagination .btn-next {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
            }

            /deep/ .el-pager li {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                line-height: 32px;
                margin-right: 8px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }

            /deep/ .el-pager li.active {
                background: #000000;
                color: #ffffff;
            }

            /deep/ .el-input--mini .el-input__inner {
                height: 32px;
            }

            /deep/ .el-input__inner {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }
        }
    }

    .freeze {
        .freeze-div {
            text-align: center;

            .freeze-div-img {
                width: 56px;
                height: 56px;
            }

            .freeze-div-title {
                height: 32px;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                line-height: 32px;
            }

            .freeze-div-text {
                width: 319px;
                height: 40px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                line-height: 20px;
                margin: 0 auto;
                margin-top: 2px;
            }

            .freeze-div-button {
                width: 100%;
                height: 32px;
                margin-top: 18px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                .freeze-div-button-left,
                .freeze-div-button-right {
                    width: 88px;
                    height: 32px;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    border-radius: 10px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 32px;
                }

                .freeze-div-button-right {
                    width: 88px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    margin-left: 10px;

                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
    }
}
</style>
